import { Form } from "@circle-react-shared/uikit/Form";
import { Box } from "@circleco/compass/components/Box";

import { t } from "@/i18n-js/instance";
import { canManageSpace } from "@/react/helpers/spaceHelpers";
import type { ImagePost } from "@/react/types";
import type { Space } from "@/react/types/Space";

import { ImagePostSeoSection } from "../ImagePostSeoSection";
import { CaptionEditor } from "./CaptionEditor";
import { Options } from "./Options";
import { ScheduledPostBox } from "./ScheduledPostBox";
import { TopicsField } from "./TopicsField";

interface ImagePostFormProps {
  post: ImagePost;
  showScheduledPostBox?: boolean;
  space?: Space;
}

export const ImagePostForm = ({
  post,
  showScheduledPostBox = true,
  space,
}: ImagePostFormProps) => {
  const canCreateTopics = space ? canManageSpace(space) : false;

  if (!space) {
    return null;
  }

  const shouldShowTopics = Number(space.topics_count) > 0 || canCreateTopics;

  return (
    <div className="flex w-full min-w-0 flex-col gap-3">
      {showScheduledPostBox && <ScheduledPostBox post={post} space={space} />}
      <Box>
        <CaptionEditor space={space} post={post} />
        {shouldShowTopics && (
          <Form.Item
            name="topics"
            hideDescription
            hideBorder
            label={t("image_space.post_modal.steps.create_post.topics_label")}
            labelClassName="!mb-3 !text-label-sm"
          >
            <div className="rounded-md border border-primary px-2 py-1.5">
              <TopicsField
                spaceId={String(space.id)}
                creatable={canCreateTopics}
                inline
              />
            </div>
          </Form.Item>
        )}
      </Box>
      {canManageSpace(space) && <Options space={space} />}
      {canManageSpace(space) && <ImagePostSeoSection />}
    </div>
  );
};
